import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React, { memo, useContext } from 'react';
import TabsContext from '../contexts/TabsContext.js';
import TabButton from './TabButton.js';

var _templateObject;
var StyledTabList = styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: no-wrap;\n  list-style: none;\n  margin-top: 0;\n  ", "\n"])), function (_ref) {
  var noVertical = _ref.noVertical;
  return !noVertical && "@media (max-width: 768px) {\n      flex-wrap: wrap;\n    }";
});
var TabList = function TabList(_ref2) {
  var name = _ref2.name,
    tabs = _ref2.tabs;
  var _useContext = useContext(TabsContext),
    noVertical = _useContext.noVertical;
  return /*#__PURE__*/React.createElement(StyledTabList, {
    role: "tablist",
    noVertical: noVertical,
    "aria-labelledby": name
  }, tabs.map(function (_ref3) {
    var name = _ref3.name,
      label = _ref3.label,
      onClick = _ref3.onClick;
    return /*#__PURE__*/React.createElement(TabButton, {
      id: name,
      label: label,
      key: name,
      name: name,
      onClick: onClick
    });
  }));
};
var TabList$1 = /*#__PURE__*/memo(TabList);

export default TabList$1;
